import React from 'react'
import { useSelector } from 'react-redux'
import { GallerySection, LanguageChecker, ShareButtons } from '../../../components'
import { useViewport } from '../../../utils'
import ActionButtons from './action-buttons'

const Default = () => {
  return (
    <div className="blog-content">
      <h6>
        <b>PeaceGen berkolaborasi dengan Gerakan Islam Cinta (GIC) dan Jaringan Gusdurian Indonesia (JGI) melalui gerakan #SalingJaga mendistribusikan bantuan sembako kepada warga terdampak Covid-19 di Bandung Raya.</b>
      </h6>
      <p>
      PeaceGen dibantu AoP dan relawan #SalingJaga yang berkoordinasi dengan RT/RW untuk mendata dan mendistribusikan bantuan tersebut kepada masyarakat miskin dan pekerja informal sebagai satu kelompok rentan yang sulit menyambung hidup pada situasi seperti ini.
      <br /><br />
      Warga yang menerima bantuan merasa sangat terbantu, setidaknya kebutuhan pokok dapat terpenuhi selama satu bulan ke depan, sebagaimana yang disampaikan oleh Bapak Ganda seorang pengemudi ojek pangkalan di Soreang kepada relawan #SalingJaga
      </p>
        <img src="/images/blog/khub_blog_detail.jpg" alt="blog" />
      <p>
      “Saya sebagai ojek pangkalan merasa bersyukur dan terima kasih atas bantuannya. Karena mengenai penghasilan setelah tidak aktif semua kegiatan bisnis atau sekolah saya tidak bisa mengantarkan dan saya tidak bisa menghasilkan penghasilan yang cukup untuk kehidupan sehari-hari. Sekarang saya merasa terpuruk mengenai penghasilan saya perhari hanya mencapai Rp. 7000. Dengan bantuan ini saya sekali lagi ucapkan terima kasih.”
      <br /><br />
      Hal yang sama disampaikan juga oleh Supri seorang penjual keliling di Cijagra kepada relawan #SalingJaga
      <br /><br />
      “Sudah hampir satu bulan tidak bisa berjualan karena wabah Covid-19 ini. Beras di rumah juga habis. Bantuan ini sangat berarti untuk saya dan keluarga untuk menyambung hidup dan memenuhi kebutuhan makan sehari-hari”.
      <br /><br />
      Selama mendistribusikan bantuan, AoP dan relawan #SalingJaga memberikan masker kepada penerima bantuan dan memberikan edukasi cara penggunaan masker, cara mencuci tangan, dan cara menggunakan cairan antiseptic yang benar.
      </p>
    </div>
  )
}

const MainContent = ({blog}) => {
  const { content, image, gallery } = blog
  const language = useSelector(state => state.system.language)
  const { isDesktop } = useViewport()
  const isPlaceholder = image.toLowerCase().includes('placeholder')

  const contentRendered = typeof content === 'string' ? content : content ? content[language.name] : JSON.stringify(content)

  return (
    <div>
      {
        image &&
        <div className={`w-full h-64 lg:h-72 bg-no-repeat ${isPlaceholder ? 'bg-left' : 'bg-center'} bg-cover mb-8 lg:mb-10`} style={{backgroundImage: `url('${image}')`}}></div>
      }
      <LanguageChecker data={content}>
        {
          contentRendered ? (
            <div
              className="prose text-dark-text max-w-none"
              dangerouslySetInnerHTML={{__html: contentRendered}}
            />
          ) : (
            <Default />
          )
        }
      </LanguageChecker>

      {
        !isDesktop && <>
          <div className="mt-8">
            <ActionButtons />
          </div>
          <hr className="my-8 lg:hidden"/>
          <div className="mb-5">
            <p className="text-sm lg:text-xs font-bold mb-5 text-center lg:text-left mt-2 lg:mt-0">Share this blog</p>
            <ShareButtons url={window.location.href}/>
          </div>
        </>
      }

      <hr className="my-8 lg:my-10" />

      <GallerySection defaultImages={gallery}/>
    </div>
  )
}

export { MainContent }
